import { useEffect, useState } from "react";
import { Check, Loader2, Star } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { parsePicks, stripReviews } from "@/components/landing/ReviewStrip";

const MODES = [["five", "Newest 5-star"], ["picked", "Ones I pick"], ["all", "All newest"], ["off", "Hide strip"]];

// Owner chooses which reviews rotate under the homepage car
export const ReviewStripSettings = () => {
  const [all, setAll] = useState(null);
  const [mode, setMode] = useState("five");
  const [picks, setPicks] = useState([]);
  useEffect(() => {
    Promise.all([api.get("/reviews?limit=30"), api.get("/site/content")]).then(([r, c]) => {
      setAll((r.data.reviews || []).filter((x) => x.body && x.source !== "seed"));
      setMode(c.data.content["reviews.strip_mode"] || "five");
      setPicks(parsePicks(c.data.content["reviews.strip_picks"]));
    }).catch(() => setAll([]));
  }, []);
  const save = (patch) => api.put("/admin/site/content", patch).then(() => toast.success("Review strip updated")).catch((e) => toast.error(e?.response?.data?.detail || "Couldn't save"));
  const pickMode = (m) => { setMode(m); save({ "reviews.strip_mode": m }); };
  const toggle = (id) => { const next = picks.includes(id) ? picks.filter((x) => x !== id) : [...picks, id]; setPicks(next); save({ "reviews.strip_picks": JSON.stringify(next) }); };
  const shown = all ? stripReviews(all, mode, picks).map((r) => r.review_id) : [];
  return (
    <div className="rounded-xl border border-white/10 bg-white/[0.02] p-5 space-y-3 lg:col-span-2" data-testid="review-strip-settings">
      <p className="text-white font-['Outfit']">Review strip under the homepage car</p>
      <div className="flex flex-wrap gap-2">
        {MODES.map(([m, label]) => <button key={m} onClick={() => pickMode(m)} className={`h-8 px-3 rounded-full text-xs border ${mode === m ? "border-sky-400 bg-sky-500/15 text-white" : "border-white/10 text-gray-400"}`} data-testid={`review-strip-mode-${m}`}>{label}</button>)}
      </div>
      {mode === "picked" && <p className="text-[11px] text-gray-500">{picks.length ? "Tick the reviews to show." : "Nothing ticked yet — the strip stays hidden until you tick at least one review."}</p>}
      {!all ? <Loader2 className="w-5 h-5 animate-spin text-sky-500" /> : (
        <div className="grid md:grid-cols-2 gap-2 max-h-80 overflow-y-auto">
          {all.map((r) => (
            <button key={r.review_id} onClick={() => mode === "picked" && toggle(r.review_id)} className={`text-left rounded-lg border p-3 ${shown.includes(r.review_id) ? "border-sky-400/60 bg-sky-500/5" : "border-white/5 opacity-60"} ${mode === "picked" ? "cursor-pointer" : "cursor-default"}`} data-testid={`review-strip-pick-${r.review_id}`}>
              <div className="flex items-center gap-2 text-xs"><span className="text-white">{r.author_name}</span><span className="flex">{[...Array(r.rating || 5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-sky-500 text-sky-500" />)}</span>
                {shown.includes(r.review_id) && <Check className="w-3.5 h-3.5 text-sky-400 ml-auto" />}</div>
              <p className="text-xs text-gray-400 line-clamp-2 mt-1">{r.body}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
